import { render, staticRenderFns } from "./embedded-recording.vue?vue&type=template&id=55aea3ce&scoped=true&"
import script from "./embedded-recording.vue?vue&type=script&lang=js&"
export * from "./embedded-recording.vue?vue&type=script&lang=js&"
import style0 from "./embedded-recording.vue?vue&type=style&index=0&id=55aea3ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aea3ce",
  null
  
)

component.options.__file = "embedded-recording.vue"
export default component.exports